(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9143],{

/***/ 91395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13294);
/* harmony import */ var _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_constants__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var connected_next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84162);
/* harmony import */ var _ahmdigital_logic_lib_utils_get_income_type_from_scale__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11845);
/* harmony import */ var _ahmdigital_logic_lib_utils_get_income_type_from_scale__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_utils_get_income_type_from_scale__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _action_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23094);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10453);
/* harmony import */ var _models_product__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43735);









// @ts-expect-error - Automatic, Please fix when editing this file
function changeAddress(address) {
    return {
        address: address,
        type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .ADDRESS_CHANGE */ .VB
    };
}
// @ts-expect-error - Automatic, Please fix when editing this file
var changeEmail = function(email) {
    return {
        payload: email,
        type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .EMAIL_CHANGE */ .t6
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
function changeContinuousCover(continuous, memberRelationship) {
    return {
        continuous: continuous,
        relationship: memberRelationship,
        type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .CONTINUOUS_COVER_CHANGE */ .bF
    };
}
// @ts-expect-error - Automatic, Please fix when editing this file
function changeDateOfBirth(dateOfBirth, memberRelationship) {
    return {
        dateOfBirth: moment__WEBPACK_IMPORTED_MODULE_4___default()(dateOfBirth, _ahm_constants__WEBPACK_IMPORTED_MODULE_5__/* ["default"].DATE_FORMAT.STANDARD */ .Z.DATE_FORMAT.STANDARD, true),
        relationship: memberRelationship,
        type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .DATE_OF_BIRTH_CHANGE */ .FW
    };
}
// @ts-expect-error - Automatic, Please fix when editing this file
function changeFrequency(frequency) {
    return {
        frequency: frequency,
        type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .FREQUENCY_CHANGE */ .Ep
    };
}
// @ts-expect-error - Automatic, Please fix when editing this file
function changeHasRefinedPrice(hasRefinedPrice) {
    return {
        hasRefinedPrice: hasRefinedPrice,
        type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .HAS_REFINED_PRICE */ .Jh
    };
}
// @ts-expect-error - Automatic, Please fix when editing this file
function changeHasSetBasicDetails(hasSetBasicDetails) {
    return {
        hasSetBasicDetails: hasSetBasicDetails,
        type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .HAS_SET_BASIC_DETAILS_CHANGE */ .jh
    };
}
// @ts-expect-error - Automatic, Please fix when editing this file
function changeHospitalExcess(hospitalExcess) {
    // @ts-expect-error - Automatic, Please fix when editing this file
    return function(dispatch, getState) {
        var products = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("product.data", getState());
        dispatch({
            hospitalExcess: hospitalExcess,
            products: products,
            type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .HOSPITAL_EXCESS_CHANGE */ .GO
        });
    };
}
// @ts-expect-error - Automatic, Please fix when editing this file
function changeIncome(income) {
    return {
        income: income,
        type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .INCOME_CHANGE */ .eF
    };
}
// @ts-expect-error - Automatic, Please fix when editing this file
function changeIncomeTier(incomeTier) {
    return {
        incomeTier: incomeTier,
        type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .INCOME_TIER_CHANGE */ .el
    };
}
// @ts-expect-error - Automatic, Please fix when editing this file
function changeIncomeType(incomeType) {
    return {
        incomeType: incomeType,
        type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .INCOME_TYPE_CHANGE */ .aA
    };
}
// @ts-expect-error - Automatic, Please fix when editing this file
function changePaymentMethod(method) {
    return {
        method: method,
        type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .PAYMENT_METHOD_CHANGE */ .Lg
    };
}
// @ts-expect-error - Automatic, Please fix when editing this file
function changeRebate(rebate) {
    return {
        rebate: rebate,
        type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .REBATE_CHANGE */ .yk
    };
}
// @ts-expect-error - Automatic, Please fix when editing this file
function changeScale(scale) {
    // @ts-expect-error - Automatic, Please fix when editing this file
    return function(dispatch, getState) {
        var cartProduct = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("cart.product", getState());
        if (cartProduct.type === _ahm_constants__WEBPACK_IMPORTED_MODULE_5__/* ["default"].PRODUCT_TYPE.COMBINED */ .Z.PRODUCT_TYPE.COMBINED && !_models_product__WEBPACK_IMPORTED_MODULE_6__/* ["default"].isAvailableFor */ .Z.isAvailableFor(cartProduct, scale)) {
            dispatch({
                product: null,
                type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .HOSPITAL_CHANGE */ .Dy
            });
        }
        if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(cartProduct.type, [
            _ahm_constants__WEBPACK_IMPORTED_MODULE_5__/* ["default"].PRODUCT_TYPE.PACKAGE */ .Z.PRODUCT_TYPE.PACKAGE,
            _ahm_constants__WEBPACK_IMPORTED_MODULE_5__/* ["default"].PRODUCT_TYPE.HOSPITAL */ .Z.PRODUCT_TYPE.HOSPITAL
        ]) && !_models_product__WEBPACK_IMPORTED_MODULE_6__/* ["default"].isAvailableFor */ .Z.isAvailableFor(cartProduct, scale)) {
            dispatch({
                product: {},
                type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .PRODUCT_CHANGE */ .GE
            });
        }
        dispatch({
            incomeType: _ahmdigital_logic_lib_utils_get_income_type_from_scale__WEBPACK_IMPORTED_MODULE_3___default()(scale),
            type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .INCOME_TYPE_CHANGE */ .aA
        });
        // Change the scale regardless.
        return dispatch({
            scale: scale,
            type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .SCALE_CHANGE */ .Nb
        });
    };
}
// @ts-expect-error - Automatic, Please fix when editing this file
function changeState(state) {
    return {
        state: state,
        type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .STATE_CHANGE */ .HX
    };
}
// @ts-expect-error - Automatic, Please fix when editing this file
function changeLastViewedProduct(productId) {
    return {
        lastViewedProduct: productId,
        type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .LAST_VIEWED_PRODUCT_CHANGE */ .PK
    };
}
// @ts-expect-error - Automatic, Please fix when editing this file
function changeProductType(productType) {
    // @ts-expect-error - Automatic, Please fix when editing this file
    return function(dispatch, getState) {
        var routerLocation = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("router.location.pathname", getState());
        var _obj;
        var productTypeUrls = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_1__.PRODUCT_TYPE.PACKAGE, _ahm_constants__WEBPACK_IMPORTED_MODULE_5__/* ["default"].URLS.SALES.PRODUCT_LISTING_PACKAGES */ .Z.URLS.SALES.PRODUCT_LISTING_PACKAGES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_1__.PRODUCT_TYPE.HOSPITAL, _ahm_constants__WEBPACK_IMPORTED_MODULE_5__/* ["default"].URLS.SALES.PRODUCT_LISTING_HOSPITAL */ .Z.URLS.SALES.PRODUCT_LISTING_HOSPITAL), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_1__.PRODUCT_TYPE.EXTRAS, _ahm_constants__WEBPACK_IMPORTED_MODULE_5__/* ["default"].URLS.SALES.PRODUCT_LISTING_EXTRAS */ .Z.URLS.SALES.PRODUCT_LISTING_EXTRAS), _obj);
        var isProductListingPage = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(routerLocation, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.values)(productTypeUrls));
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ package: any; hospital: any; extras: any; }'.
        if (isProductListingPage && productTypeUrls[productType] !== routerLocation) {
            // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ package: any; hospital: any; extras: any; }'.
            dispatch((0,connected_next_router__WEBPACK_IMPORTED_MODULE_2__/* .push */ .VF)(productTypeUrls[productType]));
        }
        return dispatch({
            productType: productType,
            type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .PRODUCT_TYPE_CHANGE */ .Dg
        });
    };
}
// @ts-expect-error - Automatic, Please fix when editing this file
function changeSwitching(switching) {
    return {
        switching: switching,
        type: _action_types__WEBPACK_IMPORTED_MODULE_7__/* .SWITCHING_CHANGE */ .bK
    };
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    changeAddress: changeAddress,
    changeContinuousCover: changeContinuousCover,
    changeDateOfBirth: changeDateOfBirth,
    changeEmail: changeEmail,
    changeFrequency: changeFrequency,
    changeHasRefinedPrice: changeHasRefinedPrice,
    changeHasSetBasicDetails: changeHasSetBasicDetails,
    changeHospitalExcess: changeHospitalExcess,
    changeIncome: changeIncome,
    changeIncomeTier: changeIncomeTier,
    changeIncomeType: changeIncomeType,
    changeLastViewedProduct: changeLastViewedProduct,
    changePaymentMethod: changePaymentMethod,
    changeProductType: changeProductType,
    changeRebate: changeRebate,
    changeScale: changeScale,
    changeState: changeState,
    changeSwitching: changeSwitching
});


/***/ }),

/***/ 17091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37169);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87379);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75624);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10453);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  color: ",
        ";\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin-top: 2rem;\n  padding: 1.25rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-grow: 2;\n  font-weight: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media (min-width: ",
        ") {\n    margin: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: auto;\n  @media (min-width: ",
        ") {\n    margin: 20px auto;\n    width: 748px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media (min-width: ",
        ") {\n    padding: 0.5rem 4rem 1.5rem;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var FUTURE_EFFECTIVE_DATE = moment__WEBPACK_IMPORTED_MODULE_3___default()(_config__WEBPACK_IMPORTED_MODULE_5__/* ["default"].get */ .Z.get("features:premiumChange:futureEffectiveDate")).format("D MMMM YYYY");
var MemberCallout = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    componentId: "sc-ecf02be5-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var StyledClickable = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .Clickable */ .P3).withConfig({
    componentId: "sc-ecf02be5-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.fontWeights.semibold;
});
var StyleP = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__.P).withConfig({
    componentId: "sc-ecf02be5-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var StyledModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u_).withConfig({
    componentId: "sc-ecf02be5-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var PremiumReviewModalContent = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({
    componentId: "sc-ecf02be5-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var PremiumReviewModal = function(param) {
    var _isOpen = param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, toggleModal = param.toggleModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledModal, {
        ariaLabelledBy: "premium-review-modal",
        isOpen: isOpen,
        toggleModal: toggleModal,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(PremiumReviewModalContent, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__.H1, {
                    looksLike: "h3",
                    children: "Premium Review"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .SpacerWrapper */ .Cj, {
                            variant: "marginBottomSpacer10",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__.P, {
                                children: [
                                    "Premium changes will take effect from ",
                                    FUTURE_EFFECTIVE_DATE,
                                    ". We want to make sure you’re on a cover that suits both your health and budget needs, if you have any questions let’s chat."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledClickable, {
                            to: _ahm_constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].URLS.HELP.PREMIUM_CHANGE */ .Z.URLS.HELP.PREMIUM_CHANGE,
                            children: "Learn more about premium changes"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MemberCallout, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyleP, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .Strong */ .cK, {
                                            children: "Already a member?"
                                        }),
                                        " Log in to view your new premium."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                    analytics: {
                                        label: "Premium Change Modal - Already a member Link"
                                    },
                                    to: _ahm_constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].URLS.MEMBERS.HOME */ .Z.URLS.MEMBERS.HOME,
                                    variant: [
                                        "white",
                                        "large"
                                    ],
                                    children: "Log in"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PremiumReviewModal);


/***/ }),

/***/ 12224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ premium_review_toggle_wrapper; }
});

// UNUSED EXPORTS: PremiumReviewToggleForTest, PremiumReviewToggleWrapper

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ui = __webpack_require__(93590);
// EXTERNAL MODULE: ./src/client/utils/is-feature-enabled/index.ts
var is_feature_enabled = __webpack_require__(64532);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/icons-web/lib/index.js
var lib = __webpack_require__(54312);
;// CONCATENATED MODULE: ./src/client/components/premium-change-prompt/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-size: 1rem;\n      padding: 1rem 1.5rem;\n\n      @media (max-width: ",
        ") {\n        width: 100%;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-size: 0.875rem;\n      margin: 1.25rem 0 0.625rem;\n      margin-left: -12%;\n      padding: 0.625rem 0.25rem;\n      position: relative;\n      text-align: center;\n      width: 124%;\n\n      &::before,\n      &::after {\n        bottom: -0.625rem;\n        content: '';\n        height: 0;\n        position: absolute;\n        width: 0;\n      }\n\n      &::before {\n        border-left: 0.625rem solid transparent;\n        border-top: 0.625rem solid ",
        ";\n        left: 0;\n      }\n\n      &::after {\n        border-right: 0.625rem solid transparent;\n        border-top: 0.625rem solid ",
        ";\n        right: 0;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-weight: ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      text-align: center;\n      width: 100%;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      border-bottom: 1px solid ",
        ";\n      border-top: 1px solid ",
        ";\n      padding: 1rem 1.5rem;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  line-height: 2.3rem;\n\n  ",
        "\n\n  ",
        "\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-left: 0.8rem;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      select {\n        color: white;\n      }\n\n      @media (max-width: ",
        ") {\n        display: inline;\n\n        select {\n          width: 100%;\n        }\n      }\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  margin-right: 0.8rem;\n\n  & > div {\n    margin-bottom: 0;\n  }\n  select {\n    background-color: transparent;\n    font-weight: ",
        ";\n  }\n  option {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-size: 16px;\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  top: 2px;\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}




var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-aaa3f46d-0"
})(_templateObject5(), function(param) {
    var type = param.type;
    return type === ui.PREMIUM_REVIEW_TOGGLE_STYLE.FLAT && (0,styled_components_browser_esm.css)(_templateObject(), function(param) {
        var theme = param.theme;
        return theme.colors.grey70;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.white;
    }, function(param) {
        var theme = param.theme;
        return theme.media.sm;
    });
}, function(param) {
    var type = param.type;
    return type === ui.PREMIUM_REVIEW_TOGGLE_STYLE.RIBBON && (0,styled_components_browser_esm.css)(_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.colors.grey30;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.black;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.grey40;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.grey40;
    });
}, function(param) {
    var type = param.type;
    return type === ui.PREMIUM_REVIEW_TOGGLE_STYLE.READ_ONLY && (0,styled_components_browser_esm.css)(_templateObject2(), function(param) {
        var theme = param.theme;
        return theme.fontWeights.bold;
    });
}, function(param) {
    var isAlternativePage = param.isAlternativePage;
    return isAlternativePage && (0,styled_components_browser_esm.css)(_templateObject3());
}, function(param) {
    var type = param.type;
    return type === ui.PREMIUM_REVIEW_TOGGLE_STYLE.FLAT_WHITE && (0,styled_components_browser_esm.css)(_templateObject4(), function(param) {
        var theme = param.theme;
        return theme.colors.white;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.black;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.black;
    });
});
var PremiumChangeDropdown = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-aaa3f46d-1"
})(_templateObject8(), function(param) {
    var hasMargin = param.hasMargin;
    return hasMargin && (0,styled_components_browser_esm.css)(_templateObject6());
}, function(param) {
    var theme = param.theme;
    return theme.fontWeights.bold;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, function(param) {
    var type = param.type;
    return type === ui.PREMIUM_REVIEW_TOGGLE_STYLE.FLAT && (0,styled_components_browser_esm.css)(_templateObject7(), function(param) {
        var theme = param.theme;
        return theme.media.sm;
    });
});
var StyledIcon = (0,styled_components_browser_esm["default"])(lib["default"]).withConfig({
    componentId: "sc-aaa3f46d-2"
})(_templateObject10(), function(param) {
    var type = param.type;
    return type === ui.PREMIUM_REVIEW_TOGGLE_STYLE.RIBBON && (0,styled_components_browser_esm.css)(_templateObject9());
});
var DateStartText = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-aaa3f46d-3"
})(_templateObject11());
var HelpLink = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-aaa3f46d-4"
})(_templateObject12());

// EXTERNAL MODULE: ./src/client/features/premium-change/constants.ts
var constants = __webpack_require__(47569);
// EXTERNAL MODULE: ./src/client/actions/price/index.ts
var price = __webpack_require__(77061);
// EXTERNAL MODULE: ./src/client/selectors/select-is-premium-change-enabled/index.ts
var select_is_premium_change_enabled = __webpack_require__(45424);
// EXTERNAL MODULE: ./src/client/components/premium-change-prompt/styles.module.sass
var styles_module = __webpack_require__(81573);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/components/premium-change-prompt/index.tsx













var formattedEffectiveDate = moment_default()(constants/* default.FUTURE_EFFECTIVE_DATE */.Z.FUTURE_EFFECTIVE_DATE).format("D MMMM");
// @ts-expect-error: Lodash hasn't typed map to include convert.
var mapWithKey = fp.map.convert({
    cap: false
});
var options = mapWithKey(function(value, key) {
    return {
        text: value,
        value: key
    };
}, constants/* default.TOGGLE_LABELS */.Z.TOGGLE_LABELS);
var PremiumChangePrompt = function(param) {
    var actions = param.actions, _isAlternativePage = param.isAlternativePage, isAlternativePage = _isAlternativePage === void 0 ? false : _isAlternativePage, _isPremiumChangeEnabled = param.isPremiumChangeEnabled, isPremiumChangeEnabled = _isPremiumChangeEnabled === void 0 ? false : _isPremiumChangeEnabled, toggleModal = param.toggleModal, _type = param.// @ts-expect-error - Automatic, Please fix when editing this file
    type, type = _type === void 0 ? null : _type, useFutureEffectiveDate = param.useFutureEffectiveDate;
    if (!isPremiumChangeEnabled) {
        return null;
    }
    var onChange = function(event) {
        var effectiveDateChangeValue = event.target.value;
        var shouldChangeEffectiveDate = effectiveDateChangeValue === "true";
        actions.price.changeEffectiveDate(shouldChangeEffectiveDate);
    };
    var isReadOnly = type === ui.PREMIUM_REVIEW_TOGGLE_STYLE.READ_ONLY;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        isAlternativePage: isAlternativePage,
        type: type,
        children: [
            isReadOnly ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    " ",
                    useFutureEffectiveDate ? ui.USE_FUTURE_EFFECTIVE_DATE.AFTER : ui.USE_FUTURE_EFFECTIVE_DATE.BEFORE,
                    " "
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumChangeDropdown, {
                type: type,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Field */.gN, {
                    className: (styles_module_default()).container,
                    inputVariant: [
                        "inline",
                        "sharp",
                        (styles_module_default()).input
                    ],
                    name: "premiumChangeToggle",
                    onChange: onChange,
                    options: options,
                    size: "auto",
                    type: "dropdown",
                    value: (0,fp.toString)(useFutureEffectiveDate),
                    label: "Price",
                    labelVariant: (styles_module_default()).label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DateStartText, {
                children: [
                    formattedEffectiveDate,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpLink, {
                        onClick: toggleModal,
                        "aria-label": "More about Premium Review",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                            fill: "currentColor",
                            name: "question-circle",
                            type: type
                        })
                    })
                ]
            })
        ]
    });
};
var mapStateToProps = function(state) {
    return {
        isPremiumChangeEnabled: (0,select_is_premium_change_enabled/* default */.Z)(state),
        useFutureEffectiveDate: state.price.useFutureEffectiveDate
    };
};
var mapDispatchToProps = function(dispatch) {
    return {
        actions: {
            price: (0,redux/* bindActionCreators */.DE)(price/* default */.Z, dispatch)
        }
    };
};
/* harmony default export */ var premium_change_prompt = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(PremiumChangePrompt));


// EXTERNAL MODULE: ./src/client/components/premium-review-modal/index.tsx
var premium_review_modal = __webpack_require__(17091);
;// CONCATENATED MODULE: ./src/client/components/premium-review-toggle-wrapper/index.tsx







var PremiumReviewToggleWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-34618aee-0"
})(function(param) {
    var hasEvenSpacing = param.hasEvenSpacing, showBackground = param.showBackground, isProductPage = param.isProductPage, theme = param.theme, type = param.type;
    var styles = {
        textAlign: "center"
    };
    if (showBackground) {
        styles.backgroundColor = theme.colors.black;
    }
    if (hasEvenSpacing) {
        styles.paddingTop = "1rem";
    }
    switch(type){
        case ui.PREMIUM_REVIEW_TOGGLE_STYLE.RIBBON:
            break;
        case ui.PREMIUM_REVIEW_TOGGLE_STYLE.FLAT:
        case ui.PREMIUM_REVIEW_TOGGLE_STYLE.FLAT_WHITE:
        case ui.PREMIUM_REVIEW_TOGGLE_STYLE.ALTERNATIVE_PAGE:
            styles.marginBottom = isProductPage ? "0" : "1rem";
            break;
        case ui.PREMIUM_REVIEW_TOGGLE_STYLE.SOFT_BUNDLE_PAGE:
            Object.assign(styles, {
                marginBottom: "1rem",
                order: 1,
                textAlign: "left"
            });
            break;
        case ui.PREMIUM_REVIEW_TOGGLE_STYLE.INLINE:
            Object.assign(styles, {
                display: "inline-block",
                marginBottom: "0",
                marginLeft: "3rem",
                marginTop: "0"
            });
            break;
        case ui.PREMIUM_REVIEW_TOGGLE_STYLE.COMPARER_PAGE:
            Object.assign(styles, {
                marginBottom: "0",
                marginTop: "1rem",
                textAlign: "left"
            });
            break;
        default:
            break;
    }
    return (0,styled_components_browser_esm.css)(styles);
});
var PremiumReviewToggle = function(param) {
    var _hasEvenSpacing = param.hasEvenSpacing, hasEvenSpacing = _hasEvenSpacing === void 0 ? false : _hasEvenSpacing, _isProductPage = param.isProductPage, isProductPage = _isProductPage === void 0 ? false : _isProductPage, _hasMargin = param.hasMargin, hasMargin = _hasMargin === void 0 ? true : _hasMargin, _showBackground = param.showBackground, showBackground = _showBackground === void 0 ? false : _showBackground, _type = param.type, type = _type === void 0 ? ui.PREMIUM_REVIEW_TOGGLE_STYLE.FLAT : _type;
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var toggleModal = function() {
        setIsModalOpen(!isModalOpen);
    };
    if (!(0,is_feature_enabled/* default */.Z)("premiumChange")) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PremiumReviewToggleWrapper, {
        hasEvenSpacing: hasEvenSpacing,
        hasMargin: hasMargin,
        isProductPage: isProductPage,
        showBackground: showBackground,
        type: type,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(premium_change_prompt, {
                type: type,
                toggleModal: toggleModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(premium_review_modal/* default */.Z, {
                isOpen: isModalOpen,
                toggleModal: toggleModal
            })
        ]
    });
};
/* harmony default export */ var premium_review_toggle_wrapper = (PremiumReviewToggle);



/***/ }),

/***/ 45424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22222);
/* harmony import */ var _features_premium_change_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47569);
/* harmony import */ var _select_cart_product_id__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94715);



var getEnabledProduct = function() {
    return(//   Premium change for November 1 2022 will be run on all products
    _features_premium_change_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENABLED */ .Z.ENABLED);
};
// Being used as a selector due to unpredictability of products affected by premium review year to year
var selectIsPremiumChangeEnabled = (0,reselect__WEBPACK_IMPORTED_MODULE_0__.createSelector)(_select_cart_product_id__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, getEnabledProduct);
/* harmony default export */ __webpack_exports__["Z"] = (selectIsPremiumChangeEnabled);


/***/ }),

/***/ 9805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10453);


// @ts-expect-error - Automatic, Please fix when editing this file
var getDateOfBirthFromAge = function(age) {
    var guessedAge = moment__WEBPACK_IMPORTED_MODULE_0___default()().subtract(age, "years").subtract(1, "months"); // This needs to be done as api response can mistake todays date as not being 18.
    var lowerBounded = moment__WEBPACK_IMPORTED_MODULE_0___default().max(moment__WEBPACK_IMPORTED_MODULE_0___default()("1900-01-01"), guessedAge);
    var upperBounded = moment__WEBPACK_IMPORTED_MODULE_0___default().min(lowerBounded, moment__WEBPACK_IMPORTED_MODULE_0___default()());
    return upperBounded.format(_ahm_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"].DATE_FORMAT.STANDARD */ .Z.DATE_FORMAT.STANDARD);
};
/* harmony default export */ __webpack_exports__["Z"] = (getDateOfBirthFromAge);


/***/ }),

/***/ 81573:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","label":"styles_label__UOlVr","input":"styles_input__9A9lr","container":"styles_container__7wB_L"};

/***/ })

}]);